import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Subscription } from "rxjs";
import { environment } from "../../../../environments/environment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { CoreCOMService } from "../../services/com.service";

interface LocationDialogModaldata {
  title: string | (() => string);
  description: string | (() => string);
  buttonText: string | (() => string);
  //icon?: boolean;
}
@Component({
  selector: "locationDialog",
  templateUrl: "./locationDialog.component.html",
  styleUrls: ["./locationDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationDialogComponent implements OnInit, OnDestroy {
  private _localeChangeSubscription: Subscription;

  constructor(public bottomSheetRef: MatBottomSheetRef<LocationDialogComponent>
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: LocationDialogModaldata) { }

  ngOnInit() {
    this._localeChangeSubscription = this._internationalisationService.localeChanged.subscribe(() => {
      this.PushChanges();
    });
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OrderResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public confirm() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public evaluateLanguageString(s: string | (() => string) | boolean): string {
    const me = this;
    if (typeof s === "string") {
      return me._coreLanguageService.value(s);
    } else if (typeof s === "function") {
      return s();
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
  }
}
